/* Sou Voe - Calculadora de frete por CEP (produto + carrinho)
   Regras da pagina de produto: objeto CFG abaixo (espelha Configuracoes > Frete e entrega).
   No carrinho as taxas vem direto do Shopify (/cart/shipping_rates.json). */
(function(){
  if (document.getElementById('sv-frete-css')) return;
  var s = document.createElement('style'); s.id = 'sv-frete-css';
  s.textContent = ".sv-frete{margin:18px 0 6px;font-size:14px;line-height:1.4;color:inherit}.sv-frete__titulo{display:flex;align-items:center;gap:8px;font-weight:600;margin:0 0 8px}.sv-frete__form{display:flex;gap:8px}.sv-frete__input{flex:1;min-width:0;height:44px;padding:0 12px;border:1px solid #cfd6d1;border-radius:6px;font:inherit;background:#fff;color:#222}.sv-frete__input:focus{outline:none;border-color:#537a5e;box-shadow:0 0 0 2px rgba(83,122,94,.15)}.sv-frete__btn{height:44px;padding:0 18px;border:0;border-radius:6px;background:#537a5e;color:#fff;font:inherit;font-weight:600;cursor:pointer}.sv-frete__btn:disabled{opacity:.6;cursor:wait}.sv-frete__link{display:inline-block;margin-top:6px;font-size:12px;color:#6b6b6b;text-decoration:underline}.sv-frete__res:not(:empty){margin-top:10px}.sv-frete__local{font-size:12px;color:#6b6b6b;margin:0 0 6px}.sv-frete__opcoes{list-style:none;margin:0;padding:0;border:1px solid #e3e7e4;border-radius:6px;overflow:hidden}.sv-frete__opcoes li{display:flex;justify-content:space-between;align-items:center;gap:12px;padding:10px 12px;margin:0;background:#fff}.sv-frete__opcoes li+li{border-top:1px solid #e3e7e4}.sv-frete__nome{display:block;font-weight:600}.sv-frete__prazo{display:block;font-size:12px;color:#6b6b6b}.sv-frete__preco{font-weight:600;white-space:nowrap}.sv-frete__gratis{color:#537a5e}.sv-frete__dica{margin:8px 0 0;font-size:13px;color:#537a5e}.sv-frete__erro{margin:0;font-size:13px;color:#b42318}.sv-frete__input::placeholder{color:#8a8a8a;opacity:1}.sv-frete--carrinho{margin:0 0 12px;font-size:13px}.sv-frete--carrinho .sv-frete__titulo{margin-bottom:6px}.sv-frete--carrinho .sv-frete__input,.sv-frete--carrinho .sv-frete__btn{height:40px}.sv-frete--carrinho .sv-frete__link,.sv-frete--carrinho .sv-frete__local{display:none}.sv-frete--carrinho .sv-frete__res:not(:empty){margin-top:8px}.sv-frete--carrinho .sv-frete__opcoes li{padding:7px 10px}.sv-frete--carrinho .sv-frete__dica{margin-top:6px}";
  document.head.appendChild(s);
})();

(function(){
  if (window.__svFrete) return; window.__svFrete = true;

  /* Regras exibidas na PAGINA DE PRODUTO (espelham Configuracoes > Frete e entrega).
     No carrinho as taxas sao lidas direto do Shopify. */
  var CFG = {
    gratisAcima: 129,
    regras: {
      SP:     [ {nome:'Expresso', preco:15.90, dias:[1,2]}, {nome:'Econômico', preco:15.00, dias:[3,5]} ],
      OUTROS: [ {nome:'Expresso', preco:25.00, dias:[3,5]}, {nome:'Econômico', preco:15.00, dias:[5,8]} ]
    }
  };

  var KEY = 'svFreteCep';
  var FAIXAS = [[1000,19999,'SP'],[20000,28999,'RJ'],[29000,29999,'ES'],[30000,39999,'MG'],[40000,48999,'BA'],[49000,49999,'SE'],[50000,56999,'PE'],[57000,57999,'AL'],[58000,58999,'PB'],[59000,59999,'RN'],[60000,63999,'CE'],[64000,64999,'PI'],[65000,65999,'MA'],[66000,68899,'PA'],[68900,68999,'AP'],[69000,69299,'AM'],[69300,69399,'RR'],[69400,69899,'AM'],[69900,69999,'AC'],[70000,72799,'DF'],[72800,72999,'GO'],[73000,73699,'DF'],[73700,76799,'GO'],[76800,76999,'RO'],[77000,77999,'TO'],[78000,78899,'MT'],[79000,79999,'MS'],[80000,87999,'PR'],[88000,89999,'SC'],[90000,99999,'RS']];

  function ufDoCep(cep){ var n = parseInt(cep.slice(0,5),10); for (var i=0;i<FAIXAS.length;i++){ if (n>=FAIXAS[i][0] && n<=FAIXAS[i][1]) return FAIXAS[i][2]; } return null; }
  function limpa(v){ return String(v||'').replace(/\D/g,'').slice(0,8); }
  function mascara(v){ v = limpa(v); return v.length>5 ? v.slice(0,5)+'-'+v.slice(5) : v; }
  function brl(v){ return v.toLocaleString('pt-BR',{style:'currency',currency:'BRL'}); }
  function esc(s){ return String(s||'').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function prazo(d){ if(!d||!d.length) return ''; var a=d[0], b=(d[1]!=null?d[1]:d[0]); return (a===b ? a+(a===1?' dia útil':' dias úteis') : a+' a '+b+' dias úteis'); }
  function getCep(){ try { return localStorage.getItem(KEY)||''; } catch(e){ return ''; } }
  function setCep(c){ try { localStorage.setItem(KEY,c); } catch(e){} }
  function carrinhoTotal(){ return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){return (c.total_price||0)/100;}).catch(function(){return 0;}); }
  function consultaCep(cep){
    return fetch('https://viacep.com.br/ws/'+cep+'/json/').then(function(r){return r.json();}).catch(function(){ return null; });
  }
  function erro(res,msg){ res.innerHTML = '<p class="sv-frete__erro">'+msg+'</p>'; }

  function render(res, ops, info, falta){
    var h = '';
    if (info && info.localidade) h += '<p class="sv-frete__local">Entrega para '+esc(info.localidade)+'/'+esc(info.uf)+'</p>';
    h += '<ul class="sv-frete__opcoes">' + ops.map(function(o){
      var g = o.preco === 0;
      return '<li><span><span class="sv-frete__nome">'+esc(o.nome)+'</span><span class="sv-frete__prazo">'+prazo(o.dias)+'</span></span><span class="sv-frete__preco'+(g?' sv-frete__gratis':'')+'">'+(g?'Grátis':brl(o.preco))+'</span></li>';
    }).join('') + '</ul>';
    if (falta > 0) h += '<p class="sv-frete__dica">Faltam <strong>'+brl(falta)+'</strong> para ganhar frete grátis.</p>';
    res.innerHTML = h;
  }

  function montaUI(el, calcular){
    el.innerHTML =
      '<p class="sv-frete__titulo"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.5"/><circle cx="17" cy="17.5" r="1.5"/></svg>Calcule o frete e o prazo</p>' +
      '<div class="sv-frete__form"><input class="sv-frete__input" type="text" inputmode="numeric" autocomplete="postal-code" placeholder="Digite seu CEP" maxlength="9" aria-label="CEP"><button class="sv-frete__btn" type="button">Calcular</button></div>' +
      '<a class="sv-frete__link" href="https://buscacepinter.correios.com.br/app/endereco/index.php" target="_blank" rel="noopener">Não sei meu CEP</a>' +
      '<div class="sv-frete__res" aria-live="polite"></div>';
    var input = el.querySelector('.sv-frete__input'), btn = el.querySelector('.sv-frete__btn'), res = el.querySelector('.sv-frete__res');
    input.value = mascara(getCep());
    input.addEventListener('input', function(){ input.value = mascara(input.value); });
    function rodar(){
      var cep = limpa(input.value);
      if (cep.length !== 8) { erro(res,'Digite um CEP válido com 8 números.'); return; }
      setCep(cep); btn.disabled = true; btn.textContent = '...';
      Promise.resolve(calcular(cep,res)).catch(function(){ erro(res,'Não foi possível calcular agora. Tente novamente.'); })
        .then(function(){ btn.disabled = false; btn.textContent = 'Calcular'; });
    }
    btn.addEventListener('click', rodar);
    input.addEventListener('keydown', function(e){ if (e.key === 'Enter') { e.preventDefault(); rodar(); } });
    if (limpa(input.value).length === 8) rodar();
    return { rodar: rodar, res: res };
  }

  /* ---------- Pagina de produto ---------- */
  function produto(el){
    var precos = {};
    String(el.getAttribute('data-variantes')||'').split(',').forEach(function(p){ var kv = p.split(':'); if (kv.length===2) precos[kv[0]] = parseInt(kv[1],10)/100; });
    var precoPadrao = parseInt(el.getAttribute('data-preco')||'0',10)/100;
    var escopo = el.closest('form, .product-information, .product, main') || document;
    function forma(){ return (escopo.querySelector && escopo.querySelector('form[action*="/cart/add"]')) || document.querySelector('form[action*="/cart/add"]'); }
    function precoAtual(){
      var f = forma(), idEl = f && f.querySelector('[name="id"]');
      var id = idEl && idEl.value || new URLSearchParams(location.search).get('variant');
      return (id && precos[id] != null) ? precos[id] : precoPadrao;
    }
    function qtdAtual(){
      var f = forma(), q = (f && f.querySelector('[name="quantity"]')) || document.querySelector('.product-information [name="quantity"], [name="quantity"]');
      var n = parseInt(q && q.value, 10); return n > 0 ? n : 1;
    }
    var ui = montaUI(el, function(cep, res){
      return Promise.all([consultaCep(cep), carrinhoTotal()]).then(function(a){
        var info = a[0], uf = ufDoCep(cep);
        if (info && info.erro) { erro(res,'CEP não encontrado. Confira os números.'); return; }
        if (info && info.uf) uf = info.uf;
        if (!uf) { erro(res,'CEP não encontrado. Confira os números.'); return; }
        var subtotal = precoAtual()*qtdAtual() + a[1];
        var regras = CFG.regras[uf] || CFG.regras.OUTROS, ops;
        if (subtotal >= CFG.gratisAcima) {
          var maisRapida = regras.slice().sort(function(x,y){ return x.dias[0]-y.dias[0]; })[0];
          ops = [{ nome:'Frete grátis', preco:0, dias:maisRapida.dias }];
        } else {
          ops = regras.slice().sort(function(x,y){ return x.preco-y.preco; });
        }
        render(res, ops, info, subtotal < CFG.gratisAcima ? CFG.gratisAcima - subtotal : 0);
      });
    });
    var t;
    function recalc(){ if (!ui.res.innerHTML) return; clearTimeout(t); t = setTimeout(ui.rodar, 400); }
    document.addEventListener('change', function(e){ if (e.target && (e.target.name === 'id' || e.target.name === 'quantity' || (e.target.closest && e.target.closest('variant-picker, variant-selects, variant-radios')))) recalc(); });
    document.addEventListener('click', function(e){ var f = forma(); if (f && f.contains(e.target) && e.target.closest('.plus, .minus, [name="plus"], [name="minus"]')) recalc(); });
  }

  /* ---------- Carrinho (taxas reais do Shopify) ---------- */
  function nomeAmigavel(n){ return (/expresso/i.test(n) && !/total/i.test(n)) ? 'Expresso' : 'Econômico'; }
  function calcCarrinho(cep, res){
    return consultaCep(cep).then(function(info){
      var uf = ufDoCep(cep);
      if (info && info.erro) { erro(res,'CEP não encontrado. Confira os números.'); return; }
      if (info && info.uf) uf = info.uf;
      if (!uf) { erro(res,'CEP não encontrado. Confira os números.'); return; }
      var qs = 'shipping_address[zip]='+encodeURIComponent(cep.slice(0,5)+'-'+cep.slice(5))+'&shipping_address[country]=Brazil&shipping_address[province]='+uf;
      return Promise.all([fetch('/cart/shipping_rates.json?'+qs,{credentials:'same-origin'}).then(function(r){return r.json();}), carrinhoTotal()]).then(function(a){
        var taxas = (a[0] && a[0].shipping_rates) || [];
        if (!taxas.length) { erro(res,'Não encontramos opções de entrega para esse CEP.'); return; }
        var lista = taxas.map(function(s){ return { nome:nomeAmigavel(s.name), preco:parseFloat(s.price), dias:s.delivery_days||[] }; });
        var gratis = lista.filter(function(o){ return o.preco === 0; });
        var ops;
        if (gratis.length) {
          gratis.sort(function(x,y){ return (x.dias[0]||99)-(y.dias[0]||99); });
          ops = [{ nome:'Frete grátis', preco:0, dias:gratis[0].dias }];
        } else {
          var porNome = {};
          lista.forEach(function(o){ var c = porNome[o.nome]; if (!c || o.preco < c.preco || (o.preco === c.preco && (o.dias[0]||99) < (c.dias[0]||99))) porNome[o.nome] = o; });
          ops = Object.keys(porNome).map(function(k){ return porNome[k]; }).sort(function(x,y){ return x.preco-y.preco; });
        }
        var falta = gratis.length ? 0 : Math.max(0, CFG.gratisAcima - a[1]);
        render(res, ops, info, falta);
      });
    });
  }
  function carrinho(){
    var alvos = [];
    var foot = document.querySelector('#Cart-Drawer .cart-drawer-footer');
    if (foot) alvos.push([foot, foot.firstChild]);
    if (location.pathname.replace(/\/$/,'') === '/cart') {
      var b = document.querySelector('main [name="checkout"], main [name="cc"]');
      var bloco = b && (b.closest('.cart-drawer-buttons, .cart__ctas, form') || b.parentNode);
      if (bloco && bloco.parentNode) alvos.push([bloco.parentNode, bloco]);
    }
    alvos.forEach(function(a){
      var pai = a[0];
      if (pai.querySelector(':scope > .sv-frete')) return;
      var el = document.createElement('div'); el.className = 'sv-frete sv-frete--carrinho';
      pai.insertBefore(el, a[1]);
      montaUI(el, calcCarrinho);
    });
  }

  function init(){
    document.querySelectorAll('[data-sv-frete-produto]').forEach(function(el){ if (!el.getAttribute('data-ok')) { el.setAttribute('data-ok','1'); produto(el); } });
    carrinho();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  var tm; new MutationObserver(function(){ clearTimeout(tm); tm = setTimeout(carrinho, 150); }).observe(document.documentElement, { childList:true, subtree:true });
})();
